// GEIGHT-7: the web twin of Gotrade Indonesia's notice email (ACS-76), the page GTI's push (ACS-75)
// opens. Its slug lives here only: gatsby-node.js creates the page at NOTICE_PATH, and gatsby-ssr.js,
// gatsby-browser.js and src/html.js ship it like the move page: no third-party tag (no GTM, gtag,
// Partytown, OneSignal or Adjust), noindex and out of the sitemap. Plain CommonJS, as those
// files share it.

const { isGtgMovePath } = require('./gtg-move-route');

const NOTICE_PATH = '/id/info-produk-saham-as/';

// S3 also serves the page at .../index.html (CloudFront passes paths with a dot through).
function isNoticePath(pathname) {
  if (!pathname) return false;
  const path = pathname.replace(/\/index\.html$/, '/');
  const withSlash = path.endsWith('/') ? path : `${path}/`;
  return withSlash === NOTICE_PATH;
}

// The routes that load no third-party tag: the move page and the notice page.
function isTagFreePath(pathname) {
  return isGtgMovePath(pathname) || isNoticePath(pathname);
}

module.exports = { NOTICE_PATH, isNoticePath, isTagFreePath };
